import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { Button } from '@/components/ui/button';
import { NewCampaignV2Dialog } from '@/components/buyersV2/NewCampaignV2Dialog';
import { Flame, Mail, MessageCircle, X } from 'lucide-react';

export function HotMatchBanner({ lead }) {
  const [matches, setMatches] = useState([]);
  const dismissKey = `hot-dismiss-${lead?.id}`;
  const [hidden, setHidden] = useState(false);
  const [dialog, setDialog] = useState(null);

  useEffect(() => {
    if (!lead?.id) return;
    API.get(`/leads/${lead.id}/hot-matches`).then(r => setMatches(r.data)).catch(() => setMatches([]));
  }, [lead?.id, lead?.property_zip, lead?.property_city, lead?.asking_price, lead?.marketing_price, lead?.property_type]);

  const dismissedIds = (localStorage.getItem(dismissKey) || '').split(',');
  const visible = matches.filter(m => !dismissedIds.includes(m.id));
  if (!visible.length || hidden) return null;
  const top = visible[0];

  return (
    <div data-testid="hot-match-banner" className="flex flex-wrap items-center gap-3 px-4 py-3 rounded-xl border border-red-200 bg-gradient-to-r from-red-500/15 to-amber-500/10">
      <div className="h-9 w-9 rounded-full bg-red-500 text-white flex items-center justify-center shrink-0"><Flame className="h-5 w-5" /></div>
      <div className="flex-1 min-w-[200px]">
        <p className="text-sm font-semibold text-gray-900">{visible.length} Hot buyer{visible.length > 1 ? 's' : ''} match this deal</p>
        <p className="text-xs text-gray-600" data-testid="hot-match-top">Top: <b>{top.name}</b> scored {top.score}{top.reasons?.length ? ` — ${top.reasons.slice(0, 2).join(', ')}` : ''}{visible.length > 1 ? ` · also ${visible.slice(1, 3).map(m => m.name).join(', ')}` : ''}</p>
      </div>
      <Button size="sm" data-testid="hot-match-email-btn" onClick={() => setDialog('email')} className="bg-[#0073ea] hover:bg-[#0060c2] text-white"><Mail className="h-3.5 w-3.5 mr-1" /> Email them</Button>
      <Button size="sm" data-testid="hot-match-text-btn" onClick={() => setDialog('text')} className="bg-[#25D366] hover:bg-[#1ebe5b] text-white"><MessageCircle className="h-3.5 w-3.5 mr-1" /> Text them</Button>
      <button data-testid="hot-match-dismiss" onClick={() => { localStorage.setItem(dismissKey, matches.map(m => m.id).join(',')); setHidden(true); }} className="text-gray-400 hover:text-gray-700"><X className="h-4 w-4" /></button>
      <NewCampaignV2Dialog open={dialog === 'email' || dialog === 'text'} onOpenChange={v => !v && setDialog(null)} preset={{ lead_id: lead.id, buyer_ids: visible.map(b => b.id), channel: dialog === 'text' ? 'sms' : 'email' }} />
    </div>
  );
}
